import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=34bae32b&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "./Help.vue?vue&type=style&index=0&id=34bae32b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bae32b",
  null
  
)

export default component.exports